import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import { RIGHT_COLUMN_WIDTH } from '@openx/constants/form';
import { useTranslation } from 'react-i18next';
import { FeeSummary } from '../../../../AudienceForm/components/MultiPartnerPricing/FeeSummary';
import { PartnerPricing } from '../../../../AudienceForm/components/MultiPartnerPricing/PartnerPricing';
import { useDataPartnerNames } from '../../../../hooks/useDataPartnerNames';
import type { AudiencePricingWithSupportedOperator } from '../utils/isAudiencePricing';

type MultiPartnerPricingDetailsProps = {
  pricing: AudiencePricingWithSupportedOperator;
};

export const MultiPartnerPricingDetails = ({ pricing }: MultiPartnerPricingDetailsProps) => {
  const { t } = useTranslation();

  const { partnerNames, loading, error } = useDataPartnerNames();

  return (
    <FormSection
      data-test="pricing-title-section"
      title={t('Multi Partner Audience Pricing')}
      rightColumnSize={RIGHT_COLUMN_WIDTH}
    >
      <PartnerPricing prices={pricing.pricing_by_org} partnerNames={partnerNames} loading={loading} error={error} />
      <FeeSummary totalFees={pricing.totals} operator={pricing.operator} />
    </FormSection>
  );
};
